import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';

import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { IAspNetRoles } from './asp-net-roles';
@Injectable()
export class AspNetRolesService {
    controller:string = 'AspNetRoles';
    constructor(private http: Http) { }
   
   
   GetList(Id) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {Ids:Id};
        return this.http.post(Config.apiUrl + this.controller+'/GetList', JSON.stringify(data), { headers: headers }).map(resp => resp.json());               
    }

    GetListFromPagination(idTinhThanh: number, paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging - 1;       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl +this.controller+ '/GetListPagination?idTinhThanh=' + idTinhThanh + "&currentPage="+ currentPage+"&maxSize="+ maxSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }

    GetListUserByRole(idTinhThanh: number,RoleId:string, paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging - 1;       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdTinhThanh:idTinhThanh,RoleId:RoleId,Paging:paging,MaxSize:maxSize,Keyword:keyword};
        return this.http.post(Config.apiUrl +'AspNetUsers/GetListUsersByRoles', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }


    GetItem(id:string) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {Id:id};
        return this.http.post(Config.apiUrl + this.controller+'/GetItem', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
               
    }

    Save(item:IAspNetRoles) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Delete(id) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            Id: id
        };
        return this.http.post(Config.apiUrl + this.controller+'/delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/asp-net-roles/asp-net-roles.service.ts